import { CustomCard } from './MetricComponents';

export interface TrackedEngagementPayload {
  today: number;
  yesterday: number;
  last7Days: number;
  last30Days: number;
  definition?: string;
}

function normalizePayload(raw: unknown): TrackedEngagementPayload | null {
  if (!raw || typeof raw !== 'object') return null;
  const r = raw as Record<string, unknown>;
  const n = (v: unknown) => (typeof v === 'number' && !Number.isNaN(v) ? v : 0);
  return {
    today: n(r.today),
    yesterday: n(r.yesterday),
    last7Days: n(r.last7Days),
    last30Days: n(r.last30Days),
    definition: typeof r.definition === 'string' ? r.definition : undefined,
  };
}

const rows: { label: string; key: keyof Omit<TrackedEngagementPayload, 'definition'> }[] = [
  { label: 'Today (UTC)', key: 'today' },
  { label: 'Yesterday', key: 'yesterday' },
  { label: 'Last 7 days', key: 'last7Days' },
  { label: 'Last 30 days', key: 'last30Days' },
];

/** Right-rail summary: distinct users with SDK/API tracked events (dashboard payload). */
export function TrackedActivityPanel({ data }: { data?: unknown }) {
  const engagement = normalizePayload(data);

  return (
    <CustomCard title="Tracked activity" className="shadow-sm">
      <p className="text-xs text-custom-darkSilver mb-3 leading-snug">
        People who generated at least one activity event (identify/track) in the window, not total events.
      </p>
      <ul className="space-y-3">
        {rows.map(({ label, key }) => (
          <li key={key} className="flex items-baseline justify-between gap-3 border-b border-custom-lightSilver/80 pb-2 last:border-0 last:pb-0">
            <span className="text-xs text-custom-darkSilver">{label}</span>
            <span className="text-lg font-semibold text-custom-black tabular-nums">
              {engagement != null ? engagement[key].toLocaleString() : '—'}
            </span>
          </li>
        ))}
      </ul>
      {engagement?.definition ? (
        <p className="text-[11px] text-custom-darkSilver mt-4 leading-relaxed border-t border-custom-lightSilver pt-3">
          {engagement.definition}
        </p>
      ) : null}
    </CustomCard>
  );
}
